// This import loads the firebase namespace along with all its type information.
import ReleaseScheduleAction from './release-schedule-action-model'

export async function load_releaseScheduleActions(): Promise<
  ReleaseScheduleAction[]
> {
  throw 'Not implemented'
}

export async function delete_releaseScheduleAction(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_releaseScheduleAction(): Promise<ReleaseScheduleAction> {
  throw 'Not implemented'
}
